/* Copyright (c) 2021-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { CloudAccountCloudProvider } from "~/generated/graphql";
import { IconBox } from "~/components/IconBox";
import { IconName } from "~/types/IconName";

function getProviderDisplayName(provider: CloudAccountCloudProvider): string {
  switch (provider) {
    case CloudAccountCloudProvider.Aws:
      return "AWS";
    case CloudAccountCloudProvider.Azure:
      return "Azure";
    case CloudAccountCloudProvider.Gc:
      return "Google Cloud";
    case CloudAccountCloudProvider.Ibm:
      return "IBM Cloud";
    default:
      return provider;
  }
}

const Wrap = styled(FlexContainer)`
  width: 70%;
  gap: ${theme.spacing.spacing08};
  margin: 4rem 0;
`;

type Item = {
  id: CloudAccountCloudProvider;
  iconName: IconName;
};

type Props<T extends Item> = {
  items: T[];
  selected: T["id"] | null;
  onSelect: (itemId: CloudAccountCloudProvider) => void;
};

export function IconBoxSelector<T extends Item>({
  items,
  selected,
  onSelect,
}: Props<T>) {
  return (
    <Wrap>
      {items.map((item) => {
        return (
          <IconBox
            key={item.id}
            active={selected === item.id}
            icon={<SVGIcon name={item.iconName} size="xxl" />}
            label={getProviderDisplayName(item.id)}
            onClick={() => onSelect(item.id)}
          />
        );
      })}
    </Wrap>
  );
}
